import { Box, Button, Stack, Switch, Typography } from "@mui/material";
import { styled as _styled } from "@mui/material/styles";
import styled from "styled-components";
import { ColorConf } from "../../config/color";

export const FormWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh"
});

export const TypoH5: typeof Typography = styled(Typography)(() => ({
  fontSize: "28px",
  lineHeight: "36px"
}));

export const TypoH6: typeof Typography = styled(Typography)(() => ({
  fontSize: "22px",
  lineHeight: "28px"
}));

export const TypoBodyLagre: typeof Typography = styled(Typography)(() => ({
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.5px"
}));

export const TypoLabelSmall: typeof Typography = styled(Typography)(() => ({
  fontSize: "11px",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: "0.5px"
}));

export const TypoBodySmall: typeof Typography = styled(Typography)(() => ({
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: "0.4px"
}));

export const TypoBody: typeof Typography = styled(Typography)(() => ({
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px"
}));

export const SubmitButtonContainer: typeof Box = styled(Box)(({}) => ({
  marginRight: "auto",
  marginLeft: "auto",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}));

export const StyledButton: typeof Button = styled(Button)(({}) => ({
  fontSize: 14,
  boxShadow: "none",
  textTransform: "none",
  lineHeight: "20px",
  color: ColorConf.White,
  backgroundColor: ColorConf.PrimaryForWomen,
  borderColor: ColorConf.PrimaryForWomen,
  height: 45,
  borderRadius: 20,
  fontWeight: "bold",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "&:hover": {
    backgroundColor: ColorConf.PrimaryForWomen
  }
})) as any;

export const BackButtonContainer: typeof Box = styled(Box)(({ theme }) => ({
  width: 100,
  marginLeft: "auto",
  marginRight: 10
}));

export const StyledWrapper = _styled(Stack)(() => ({
  borderRadius: 20,
  width: "100%",
  // 影をつけて浮き出る感じにした
  // https://www.bad-company.jp/react-native-shadow
  shadowColor: "#000",
  shadowOffset: {
    width: 0,
    height: 2
  },
  shadowOpacity: 0.25,
  shadowRadius: 4,
  elevation: 1
}));

export const MainWrapper = _styled(Box)(({ theme }) => ({
  // [theme.breakpoints.up(1367)]: {
  //   display: "none"
  // }
}));

export const ArrowBackIosIconWrapper = styled(Box)(({}) => ({
  left: 10,
  position: "fixed",
  height: 50,
  width: 50
}));

export const CustomSwitch = _styled(Switch)(({ theme }) => ({
  width: 58,
  height: 32,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: "8px 5px",
    "&.Mui-checked": {
      transform: "translateX(28px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: ColorConf.PrimaryForWomen,
        opacity: 1,
        border: `1px solid ${ColorConf.PrimaryForWomen}`
      },
      "& .MuiSwitch-thumb": {
        width: 22,
        height: 22,
        backgroundColor: ColorConf.White
      },
      padding: "5px 3px"
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: ColorConf.White,
      border: `6px solid ${ColorConf.White}`
    }
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 16,
    height: 16,
    backgroundColor: ColorConf.MonoAlternate
  },
  "& .MuiSwitch-track": {
    borderRadius: 18,
    backgroundColor: ColorConf.MonoBorder,
    opacity: 1,
    border: `1px solid ${ColorConf.MonoAlternate}`,
    transition: theme.transitions.create(["background-color", "border"])
  }
}));
